import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
	// How dates are shown. Converts a Date object into a string with format "DD.MM.YYYY"
	public override format(date: Date, displayFormat: Record<string, unknown> | string): string {
		const day = this.to2Digit(date.getDate());
		const month = this.to2Digit(date.getMonth() + 1);
		const year = date.getFullYear();

		const formatKey = typeof displayFormat === 'string' ? displayFormat : Object.values(displayFormat)[0];

		// Ensures that the 'month and year' label is displayed correctly, e.g. "Juli 2025"
		if (formatKey === 'MMMM yyyy') {
			return new Intl.DateTimeFormat(this.locale, {
				month: 'long',
				year: 'numeric',
			}).format(date);
		}

		return `${day}.${month}.${year}`;
	}

	// How dates are parsed. Parses a string in "DD.MM.YYYY" format
	public override parse(value: string): Date | null {
		const trimmed = value.trim();
		if (!trimmed) return null;

		const parts = trimmed.split('.');
		if (parts.length === 3) {
			const [dayStr, monthStr, yearStr] = parts;
			const day = Number(dayStr);
			const month = Number(monthStr);
			const year = Number(yearStr);

			// Ensure day, month, and year are valid numbers within expected ranges
			if (
				!isNaN(day) &&
				!isNaN(month) &&
				!isNaN(year) &&
				day > 0 &&
				day <= 31 &&
				month > 0 &&
				month <= 12 &&
				yearStr.length === 4
			) {
				return new Date(year, month - 1, day);
			}
		}
		return this.invalid();
	}

	/**
	 * Converts one digit numbers to two digits with a leading "0".
	 */
	private to2Digit(number: number): string {
		return ('00' + number).slice(-2);
	}
}
